export interface TransactionsProps {
  type: TransactionsType
}

export enum TransactionsType {
  transactions = 'transactions',
  settlements = 'settlements',
  refunds = 'refunds',
  disputes = 'disputes',
  paymentlinks = 'links',
  bulkrefund = 'bulkRefund',
  subscriptions = 'subscriptions',
  reports = 'reports',
  payoutsbeneficiary = 'payoutsbeneficiary',
}

export interface TransactionDataType {
  id: string
  merchantRefNo: string
  jioMoneyRef: string
  bankRefNo: string
  paymentMode: string
  paymentType: string
  date: string
  totalAmount: number
  transactionStatus: string
  action: string
}

export interface ActionsMenuProps {
  path: string
  enableRefundsAction?: boolean
  testID?: string
  generateSettlementFile?: (type: string) => void
  handleExport?: (type: string, path: string, selectedDateInfo: any) => void
  fetchDetailOfPath?: () => void
  fetchTxnColumns?: () => void
  fieldSettingVisible: boolean
  setFieldSettingVisible: (data: boolean) => void
  filterVisible: boolean
  setFilterVisible: (data: boolean) => void
  generateFileHandler?: any
  hideFieldSettings?: boolean
  fetchDetailsOnFiltersClick?: () => void
  onSearchTextChange?: (text: string) => void
  handleCampaignSearch?: any
  onDownloadRefreshList?: (isRefresh: boolean) => void
  selectedDateInfo?: any
  updateSelectedDate?: any
  defaultMaxDate?: Date
  onReportTemplatesPress?: any
  hideExportButton?: boolean
  maxRange?: number
  scrollToCurrentDate?: boolean
  refundTabIndex?: any
  setRefundTabIndex?: any
  refundTabBarData?: any
  showExportOnRight?: boolean
  screenName?: string
  hideDateSelector?: boolean
  handleTokenizationSearch?: any
  selectedTabIndex?: number
  setSelectedTabIndex?: any
  showCalendarOnRight?: boolean
  showFieldSettingsAndFilters?: boolean
  handleRefundsSearchBy?: any
  apiHandler?: any
}
